module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('create-target-slot', {
    attrs: {
      "title": _vm.title,
      "showBackButton": _vm.showBackButton,
      "png": _vm.dataSourceIcon
    }
  }, [_c('create-ad', {
    attrs: {
      "targetName": _vm.targetName,
      "onComplete": _vm.onComplete
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9945f4da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/targetSlots/CreateADTargetSlot.vue
// module id = 1974
// module chunks = 0